var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["progress-bar-tooltip-container", _vm.customClass] },
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.tooltipContent,
            contentClass: _vm.tooltipContentClass,
            placement: _vm.tooltipPlacement,
            arrow: _vm.tooltipArrow,
            disabled: _vm.tooltipDisabled,
            theme: _vm.tooltipTheme,
            delay: _vm.tooltipDelay
          }
        },
        [
          _c("CompassProgressBar", {
            attrs: {
              state: _vm.progressBarState,
              caption: _vm.progressBarCaption,
              type: _vm.progressBarType
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }